import React from "react";

import { Box, Grid } from "@mui/material";

import { FileUploadButton } from "components/MUIExtensions/FileUploadButton";

export const PhotoUploadGrid = ({
  photos,
  onPhotosChange,
  buttonText = "Enviar foto",
}: PhotoUploadGridProps) => {
  const handleFileUpdate = (file: File, pos: number) => {
    const updatedPhotos = photos && photos.length ? [...photos] : new Array(3);
    updatedPhotos.splice(pos, 1, file);
    onPhotosChange(updatedPhotos);
  };

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 30%)",
        maxWidth: "100%",
        justifyContent: "space-between",
      }}
    >
      <Grid item container key={0} sx={{ flex: 1 }}>
        <FileUploadButton
          text={buttonText}
          fileName={photos && photos[0] ? photos[0].name : ""}
          onFileUpload={(file) => handleFileUpdate(file, 0)}
        />
      </Grid>
      <Grid item container key={1} sx={{ flex: 1 }}>
        <FileUploadButton
          text={buttonText}
          fileName={photos && photos[1] ? photos[1].name : ""}
          onFileUpload={(file) => handleFileUpdate(file, 1)}
        />
      </Grid>
      <Grid item container key={2} sx={{ flex: 1 }}>
        <FileUploadButton
          text={buttonText}
          fileName={photos && photos[2] ? photos[2].name : ""}
          onFileUpload={(file) => handleFileUpdate(file, 2)}
        />
      </Grid>
    </Box>
  );
};

export type PhotoUploadGridProps = {
  photos?: File[];
  onPhotosChange: (photos: File[]) => void;
  buttonText?: string;
};
